import React, { useState, useEffect } from "react";
import {
  Filter,
  RefreshCw,
  UserCheck,
  TrendingUp,
  Download,
  ChevronDown,
} from "lucide-react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  downloadUserReport,
  getUserRegistrationReport,
} from "../../../api/reportAPI";
import logger from "../../../utils/logger";
import { toISOForDB } from "../../../utils/Date";
import DateInput from "react-calendar-ui-kit";

// interface GraphDataPoint {
//   name: string;
//   count: number;
// }

// interface UserCounts {
//   Individual: {
//     count: number;
//     graphData: GraphDataPoint[];
//   };
//   Advocate: {
//     count: number;
//     graphData: GraphDataPoint[];
//   };
// }

// interface User {
//   id: number;
//   name: string;
//   email: string;
//   role: "Individual" | "Advocate";
//   registeredOn: string;
// }

// type FilterType = "All" | "custom" | "week" | "month" | "year";

// interface GraphDataPoint {
//   name: string;
//   individual: number;
//   advocate: number;
// }

// interface UserCounts {
//   Individual: number;
//   Advocate: number;
//   Total: number;
//   graphData: GraphDataPoint[];
// }

// const RegistrationReport: React.FC = () => {
//   const [counts, setCounts] = useState<UserCounts>({
//     Individual: 0,
//     Advocate: 0,
//     Total: 0,
//     graphData: [],
//   });

//   const [users, setUsers] = useState<User[]>([]);
//   const [selectedFilter, setSelectedFilter] = useState<FilterType>("All");
//   const [from, setFrom] = useState<string>("");
//   const [to, setTo] = useState<string>("");
//   const [loading,setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string>("");
//   const [exportLoading, setExportLoading] = useState<string | null>(null);

// const fetchReport = async (
//   filter: FilterType = "All",
//   fromDate?: string,
//   toDate?: string
// ) => {
//   try {
//     setLoading(true);
//     setError("");
//     const data = await getUserRegistrationReport(filter, fromDate, toDate);
//     setCounts({
//       Individual: data.totalIndividual,
//       Advocate: data.totalAdvocate,
//       Total: data.total,
//       graphData: data.graphData,
//     });
//   } catch (err) {
//     logger.error(err);
//     setError("Failed to fetch registration data");
//   } finally {
//     setLoading(false);
//   }
// };

//   useEffect(() => {
//     if (selectedFilter !== "custom") {
//       fetchReport(selectedFilter);
//     }
//   }, [selectedFilter]);

//   // utils
//   const isValidDate = (dateStr: string) => {
//     return !isNaN(new Date(dateStr).getTime());
//   };

//   // handle filter change
//   const handleFilterChange = (filter: FilterType) => {
//     setSelectedFilter(filter);
//     setError("");
//     if (filter !== "custom") {
//       setFrom("");
//       setTo("");
//       applyPredefinedFilter(filter);
//     }
//   };

//   const handleDateInputValidation = (
//     value: string,
//     setter: React.Dispatch<React.SetStateAction<string>>
//   ) => {
//     if (!isValidDate(value)) {
//       setError("Invalid date selected");
//       return;
//     }
//     setError("");
//     setter(value);
//   };

//   const handleExport = async (type: string) => {
//     setExportLoading(type);
//     try {
//       const dataStr = JSON.stringify(users, null, 2);
//       const blob = new Blob([dataStr], { type: "application/json" });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `registration-report.${type}.json`; // mock only
//       link.click();
//     } catch (err) {
//       setError("Failed to export report");
//     } finally {
//       setExportLoading(null);
//     }
//   };

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const usersPerPage = 10;

//   // Mock Data
//   const mockCounts: UserCounts = {
//     Individual: {
//       count: 1247,
//       graphData: [
//         { name: "2024-01-01", count: 45 },
//         { name: "2024-01-02", count: 52 },
//         { name: "2024-01-03", count: 48 },
//         { name: "2024-01-04", count: 61 },
//         { name: "2024-01-05", count: 55 },
//         { name: "2024-01-06", count: 67 },
//         { name: "2024-01-07", count: 73 },
//       ],
//     },
//     Advocate: {
//       count: 892,
//       graphData: [
//         { name: "2024-01-01", count: 12 },
//         { name: "2024-01-02", count: 18 },
//         { name: "2024-01-03", count: 15 },
//         { name: "2024-01-04", count: 22 },
//         { name: "2024-01-05", count: 19 },
//         { name: "2024-01-06", count: 25 },
//         { name: "2024-01-07", count: 28 },
//       ],
//     },
//   };

//   const applyPredefinedFilter = (filter: FilterType) => {
//     logger.log(filter);
//     setUsers(mockUsers);
//   };
//   const handleApplyFilters = () => {
//     if (selectedFilter !== "custom") return;
//     setUsers(mockUsers);
//   };

//   // reset filters
//   const handleReset = () => {
//     setSelectedFilter("All");
//     setFrom("");
//     setTo("");
//     setUsers(mockUsers);
//     setError("");
//   };

//   // Mock Users (10 Dummy)
//   const mockUsers: User[] = [
//     {
//       id: 1,
//       name: "Amit Sharma",
//       email: "amit.sharma@example.com",
//       role: "Individual",
//       registeredOn: "2024-01-05",
//     },
//     {
//       id: 2,
//       name: "Neha Verma",
//       email: "neha.verma@example.com",
//       role: "Advocate",
//       registeredOn: "2024-01-07",
//     },
//     {
//       id: 3,
//       name: "Ravi Kumar",
//       email: "ravi.kumar@example.com",
//       role: "Individual",
//       registeredOn: "2024-01-10",
//     },
//     {
//       id: 4,
//       name: "Priya Singh",
//       email: "priya.singh@example.com",
//       role: "Advocate",
//       registeredOn: "2024-01-12",
//     },
//     {
//       id: 5,
//       name: "Arjun Mehta",
//       email: "arjun.mehta@example.com",
//       role: "Individual",
//       registeredOn: "2024-01-15",
//     },
//     {
//       id: 6,
//       name: "Sonal Kapoor",
//       email: "sonal.kapoor@example.com",
//       role: "Advocate",
//       registeredOn: "2024-01-17",
//     },
//     {
//       id: 7,
//       name: "Karan Patel",
//       email: "karan.patel@example.com",
//       role: "Individual",
//       registeredOn: "2024-01-20",
//     },
//     {
//       id: 8,
//       name: "Meera Joshi",
//       email: "meera.joshi@example.com",
//       role: "Advocate",
//       registeredOn: "2024-01-22",
//     },
//     {
//       id: 9,
//       name: "Vikram Rao",
//       email: "vikram.rao@example.com",
//       role: "Individual",
//       registeredOn: "2024-01-25",
//     },
//     {
//       id: 10,
//       name: "Anjali Gupta",
//       email: "anjali.gupta@example.com",
//       role: "Advocate",
//       registeredOn: "2024-01-28",
//     },
//   ];

//   useEffect(() => {
//     setCounts(mockCounts);
//     setUsers(mockUsers);
//   }, []);

//   const renderLineChart = (data: GraphDataPoint[], color: string) => (
//     <div className="h-40 w-full mt-4">
//       <ResponsiveContainer width="100%" height="100%">
//         <LineChart data={data}>
//           <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//           <XAxis
//             dataKey="name"
//             tick={{ fontSize: 12 }}
//             tickFormatter={(value) =>
//               new Date(value).toLocaleDateString("en-US", {
//                 month: "short",
//                 day: "numeric",
//               })
//             }
//           />
//           <YAxis tick={{ fontSize: 12 }} />
//           <Tooltip
//             formatter={(value: any) => [value, "Registrations"]}
//             labelFormatter={(value: any) =>
//               new Date(value).toLocaleDateString()
//             }
//           />
//           <Line
//             type="monotone"
//             dataKey="count"
//             stroke={color}
//             strokeWidth={3}
//             dot={{ fill: color, strokeWidth: 2, r: 4 }}
//             activeDot={{ r: 6, stroke: color, strokeWidth: 2, fill: "#fff" }}
//           />
//         </LineChart>
//       </ResponsiveContainer>
//     </div>
//   );

//   // Pagination Logic
//   const indexOfLastUser = currentPage * usersPerPage;
//   const indexOfFirstUser = indexOfLastUser - usersPerPage;
//   const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

//   const totalPages = Math.ceil(users.length / usersPerPage);

//   const totalRegistrations = counts.Individual.count + counts.Advocate.count;

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-4">
//       {/* Filters */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
//         <div className="space-y-6">
//           <div className="flex items-center space-x-2">
//             <Filter className="w-5 h-5 text-gray-500" />
//             <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
//           </div>

//           {/* Filter Radio Buttons */}
//           <div className="space-y-4">
//             <div className="flex flex-wrap gap-3">
//               {/* Date Range */}
//               <label
//                 className={`px-4 py-2 rounded-lg border cursor-pointer transition-colors
//             ${
//               selectedFilter === "custom"
//                 ? "bg-indigo-50 border-indigo-500 text-indigo-700 font-medium"
//                 : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
//             }`}
//               >
//                 <input
//                   type="radio"
//                   name="filter"
//                   value="custom"
//                   checked={selectedFilter === "custom"}
//                   onChange={(e) =>
//                     handleFilterChange(e.target.value as FilterType)
//                   }
//                   className="hidden"
//                 />
//                 Date Range
//               </label>

//               {/* This Week */}
//               <label
//                 className={`px-4 py-2 rounded-lg border cursor-pointer transition-colors
//             ${
//               selectedFilter === "week"
//                 ? "bg-indigo-50 border-indigo-500 text-indigo-700 font-medium"
//                 : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
//             }`}
//               >
//                 <input
//                   type="radio"
//                   name="filter"
//                   value="week"
//                   checked={selectedFilter === "week"}
//                   onChange={(e) =>
//                     handleFilterChange(e.target.value as FilterType)
//                   }
//                   className="hidden"
//                 />
//                 This Week
//               </label>

//               {/* This Month */}
//               <label
//                 className={`px-4 py-2 rounded-lg border cursor-pointer transition-colors
//             ${
//               selectedFilter === "month"
//                 ? "bg-indigo-50 border-indigo-500 text-indigo-700 font-medium"
//                 : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
//             }`}
//               >
//                 <input
//                   type="radio"
//                   name="filter"
//                   value="month"
//                   checked={selectedFilter === "month"}
//                   onChange={(e) =>
//                     handleFilterChange(e.target.value as FilterType)
//                   }
//                   className="hidden"
//                 />
//                 This Month
//               </label>

//               {/* This Year */}
//               <label
//                 className={`px-4 py-2 rounded-lg border cursor-pointer transition-colors
//             ${
//               selectedFilter === "year"
//                 ? "bg-indigo-50 border-indigo-500 text-indigo-700 font-medium"
//                 : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
//             }`}
//               >
//                 <input
//                   type="radio"
//                   name="filter"
//                   value="year"
//                   checked={selectedFilter === "year"}
//                   onChange={(e) =>
//                     handleFilterChange(e.target.value as FilterType)
//                   }
//                   className="hidden"
//                 />
//                 This Year
//               </label>
//             </div>

//             {/* Custom Date Range */}
//             {selectedFilter === "custom" && (
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 pt-4 border-t border-gray-200">
//                 <div className="space-y-2">
//                   <label className="block text-sm font-medium text-gray-700">
//                     From Date
//                   </label>
//                   <div className="relative">
//                     <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
//                     <input
//                       type="date"
//                       value={from}
//                       onChange={(e) =>
//                         handleDateInputValidation(e.target.value, setFrom)
//                       }
//                       max={to || undefined}
//                       className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
//                     />
//                   </div>
//                 </div>

//                 <div className="space-y-2">
//                   <label className="block text-sm font-medium text-gray-700">
//                     To Date
//                   </label>
//                   <div className="relative">
//                     <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
//                     <input
//                       type="date"
//                       value={to}
//                       onChange={(e) =>
//                         handleDateInputValidation(e.target.value, setTo)
//                       }
//                       min={from || undefined}
//                       className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
//                     />
//                   </div>
//                 </div>

//                 <div className="flex items-end space-x-2">
//                   <button
//                     onClick={handleApplyFilters}
//                     disabled={loading}
//                     className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors disabled:opacity-50"
//                   >
//                     {loading ? (
//                       <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
//                     ) : (
//                       <Search className="w-4 h-4 mr-2" />
//                     )}
//                     Search
//                   </button>

//                   <button
//                     onClick={handleReset}
//                     className="px-4 py-2 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
//                   >
//                     Reset
//                   </button>
//                 </div>

//                 <div className="flex items-end">
//                   <div className="relative">
//                     <button
//                       className="inline-flex items-center px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
//                       onClick={() => {
//                         const exportOptions =
//                           document.getElementById("export-dropdown");
//                         exportOptions?.classList.toggle("hidden");
//                       }}
//                     >
//                       <Download className="w-4 h-4 mr-2" />
//                       Export Report
//                       <ChevronDown className="w-4 h-4 ml-2" />
//                     </button>

//                     <div
//                       id="export-dropdown"
//                       className="hidden absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-10"
//                     >
//                       <div className="py-1">
//                         {["csv", "excel", "pdf"].map((type) => (
//                           <button
//                             key={type}
//                             onClick={() => handleExport(type)}
//                             disabled={exportLoading === type}
//                             className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50"
//                           >
//                             {exportLoading === type ? (
//                               <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
//                             ) : (
//                               <Download className="w-4 h-4 mr-2" />
//                             )}
//                             Download as {type.toUpperCase()}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           {error && (
//             <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
//               <p className="text-sm text-red-600">{error}</p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//         <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <p className="text-sm font-medium text-gray-600">
//             Total Registrations
//           </p>
//           <p className="text-3xl font-bold text-blue-600">
//             {totalRegistrations.toLocaleString()}
//           </p>
//         </div>
//         <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <p className="text-sm font-medium text-gray-600">Individual Users</p>
//           <p className="text-3xl font-bold text-green-600">
//             {counts.Individual.count.toLocaleString()}
//           </p>
//         </div>
//         <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <p className="text-sm font-medium text-gray-600">Advocate Users</p>
//           <p className="text-3xl font-bold text-purple-600">
//             {counts.Advocate.count.toLocaleString()}
//           </p>
//         </div>
//       </div>

//       {/* Graph Cards */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
//         <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
//             <UserCheck className="w-5 h-5 mr-2 text-green-600" />
//             Registered Individual Users
//           </h3>
//           {renderLineChart(counts.Individual.graphData, "#10b981")}
//         </div>

//         <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
//             <TrendingUp className="w-5 h-5 mr-2 text-purple-600" />
//             Registered Advocate Users
//           </h3>
//           {renderLineChart(counts.Advocate.graphData, "#8b5cf6")}
//         </div>
//       </div>

//       {/* Users Table */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//         <div className="px-6 py-4 border-b border-gray-200">
//           <h3 className="text-lg font-semibold text-gray-900">Recent Users</h3>
//         </div>

//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   S.No.
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Name
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Email
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Role
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Registered On
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {currentUsers.length > 0 ? (
//                 currentUsers.map((user, idx) => (
//                   <tr
//                     key={user.id}
//                     className="hover:bg-gray-50 transition-colors"
//                   >
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                       {(currentPage - 1) * usersPerPage + idx + 1}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                       {user.name}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {user.email}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span
//                         className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
//                           user.role === "Individual"
//                             ? "bg-green-100 text-green-800"
//                             : "bg-purple-100 text-purple-800"
//                         }`}
//                       >
//                         {user.role}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {user.registeredOn}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td
//                     colSpan={5}
//                     className="px-6 py-12 text-center text-gray-500"
//                   >
//                     <div className="flex flex-col items-center">
//                       <Users className="w-12 h-12 text-gray-300 mb-4" />
//                       <p className="text-lg font-medium">No users found</p>
//                       <p className="text-sm">
//                         Try adjusting your filters to see more results
//                       </p>
//                     </div>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         <div className="flex justify-between items-center px-6 py-4 border-t">
//           <span className="text-sm text-gray-500">
//             Page {currentPage} of {totalPages}
//           </span>
//           <div className="space-x-2">
//             <button
//               onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//               disabled={currentPage === 1}
//               className="px-3 py-1 bg-gray-100 rounded disabled:opacity-50"
//             >
//               Prev
//             </button>
//             <button
//               onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
//               disabled={currentPage === totalPages}
//               className="px-3 py-1 bg-gray-100 rounded disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RegistrationReport;

interface GraphDataPoint {
  name: string;
  individual: number;
  advocate: number;
}

interface UserCounts {
  Individual: number;
  Advocate: number;
  Total: number;
  graphData: GraphDataPoint[];
  yearMonthGraphData?: GraphDataPoint[];
}

// type FilterType = "All" | "custom" | "week" | "month" | "year";

type FilterType = "today" | "custom" | "week" | "month" | "year";

const RegistrationReport: React.FC = () => {
  const [counts, setCounts] = useState<UserCounts>({



    Individual: 0,
    Advocate: 0,
    Total: 0,
    graphData: [],
  });

  // const [selectedFilter, setSelectedFilter] = useState<FilterType>("All");
  const [selectedFilter, setSelectedFilter] = useState<FilterType>("today");

  const [from, setFrom] = useState<string>("");
  const [to, setTo] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [_, setExportLoading] = useState<string | null>(null);
  const [resetLoading, setResetLoading] = useState(false);


  // const fetchReport = async (
  //   filter: FilterType = "today",
  //   fromDate?: string,
  //   toDate?: string
  // ) => {
  //   try {
  //     setLoading(true);
  //     setError("");
  //     const data = await getUserRegistrationReport(filter, fromDate, toDate);

  //     setCounts({
  //       Individual: data.totalIndividual || 0,
  //       Advocate: data.totalAdvocate || 0,
  //       Total: data.total || 0,
  //       graphData: data.graphData || [],
  //     });
  //   } catch (err) {
  //     logger.error(err);
  //     setError("Failed to fetch registration data");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchReport = async (
    filter: FilterType,
    fromDate?: string,
    toDate?: string,
  ) => {
    try {
      setLoading(true);
      setError("");

      const response = await getUserRegistrationReport(
        filter,
        fromDate,
        toDate,
      );

      // ✅ NO DATA CASE
      if (!response || !response.graphData || response.graphData.length === 0) {
        resetReportData();
        return;
      }

      // ✅ DATA PRESENT
      setCounts({
        Individual: response.totalIndividual || 0,
        Advocate: response.totalAdvocate || 0,
        Total: response.total || 0,
        graphData: response.graphData,
        yearMonthGraphData: response.yearMonthGraphData || [],
      });
    } catch (err) {
      logger.error("err" , err);
      resetReportData(); // ✅ error case
      setError("Failed to fetch registration data");
    } finally {
      setLoading(false);
    }
  };

  const resetReportData = () => {
    setCounts({
      Individual: 0,
      Advocate: 0,
      Total: 0,
      graphData: [],
    });
  };

  useEffect(() => {
    if (selectedFilter !== "custom") {
      fetchReport(selectedFilter);
    }
  }, [selectedFilter]);

 
const handleDateInputValidation = (
  value: string,
  setter: (val: string) => void
) => {
  if (!value) return setter("");

  const isoValue = toISOForDB(value) ?? "";
  setter(isoValue);
};

  const handleFilterChange = (filter: FilterType) => {
    setSelectedFilter(filter);
    setError("");

    // ✅ clear old data immediately
    resetReportData();

    if (filter !== "custom") {
      fetchReport(filter);
    }
  };

  const handleApplyFilters = () => {
    if (!from || !to) {
      setError("Please select From and To date");
      return;
    }

    resetReportData(); // ✅ clear first
    fetchReport("custom", from, to);
  };

  const handleReset = async () => {
    try {
      setResetLoading(true)

      setSelectedFilter("today");
      setFrom("");
      setTo("");
      setError("");
      resetReportData();
      await fetchReport("today");
    }
    catch (error) {
      logger.error("err" , error)
    }
    finally {
      setResetLoading(false)
    }
  };

  // const totalRegistrations = counts.Individual + counts.Advocate;

  const totalRegistrations = counts.Total;
  const chartData =
    selectedFilter === "year"
      ? counts.yearMonthGraphData || []
      : counts.graphData;

  const renderLineChart = (
    data: { name: string; count: number }[],
    color: string,
  ) => (
    <div className="h-65 w-full mt-4">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{ top: 30, right: 30, left: 90, bottom: 80 }} // extra breathing space
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          {/* X-Axis */}
          {/* <XAxis
            dataKey="name"
            tick={{ fontSize: 12, fill: "#555" }}
            tickMargin={20} // spacing between ticks and label
            tickFormatter={(value) =>
              new Date(value).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
              })
            }
            label={{
              value: "Dates of Registration",
              position: "bottom",
              dy: 25, // pushes label downward clearly
              fontSize: 14,
              fontWeight: 600,
              fill: "#333",
            }}
          /> */}

          {/* <XAxis
            dataKey="name"
            scale="point"
            padding={{ left: 40, right: 40 }}
            tickFormatter={(value) => {
              if (selectedFilter === "today") {
                return new Date(value).toLocaleDateString("en-GB"); // 19-12-2025
              }

              if (selectedFilter === "year") {
                const [y, m] = value.split("-");
                return new Date(+y, +m - 1).toLocaleString("en-US", {
                  month: "short",
                });
              }

              return value;
            }}
            label={{
              value:
                selectedFilter === "year"
                  ? "Month"
                  : selectedFilter === "today"
                    ? "Date"
                    : "Date",
              position: "insideBottom",
              offset: -5,
            }}
          /> */}
          <XAxis
            dataKey="name"
            tick={{ fontSize: 12 }}
            interval={0}
            tickFormatter={(value) => {
              // ✅ ONLY for THIS MONTH
              if (selectedFilter === "month") {
                return new Date(value).getDate(); // 1, 2, 3 ... 28
              }

              // 🔒 baaki sab untouched
              return value;
            }}
            label={{
              value: "Date",
              position: "insideBottom",
              offset: -5,
            }}
          />

          {/* Y-Axis */}
          {/* <YAxis
            tick={{ fontSize: 12, fill: "#555" }}
            tickMargin={10}
            label={{
              value: "Number of Registrations",
              angle: -90,
              // position: "outsideLeft",
              dx: -30, // pushes label leftward (away from ticks)
              fontSize: 14,
              fontWeight: 600,
              fill: "#333",
            }}
          /> */}
          <YAxis
            allowDecimals={false}
            domain={[0, "dataMax + 1"]}
            tick={{ fontSize: 12, fill: "#555" }}
            tickMargin={10}
            label={{
              value: "Number of Registrations",
              angle: -90,
              dx: -30,
              fontSize: 14,
              fontWeight: 600,
              fill: "#333",
            }}
          />
          {/* 
          <Tooltip
            formatter={(value) => [value, "Registrations"]}
            labelFormatter={(value) =>
              new Date(value).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })
            }
          /> */}
          <Tooltip
            formatter={(value) => [value, "Registrations"]}
            labelFormatter={(value) =>
              selectedFilter === "year" ? value : value
            }
          />

          {/* <Line
            type="monotone"
            dataKey="count"
            stroke={color}
            strokeWidth={3}
            dot={{ fill: color, strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6, stroke: color, strokeWidth: 2, fill: "#fff" }}
            label={false}
          /> */}
          <Line
            type="monotone"
            dataKey="count"
            stroke={color}
            strokeWidth={3}
            dot={false}
            activeDot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );

  // DOWNLOAD HANDLER - calls backend and triggers client download
  const handleExport = async (type: "csv" | "excel" | "pdf") => {
    try {
      setExportLoading(type);
      setError("");

      // Build params exactly as backend expects:
      // const params: any =
      //   selectedFilter === "custom"
      //     ? {
      //         filter: "custom",
      //         fromDate: from || undefined,
      //         toDate: to || undefined,
      //       }
      //     : { filter: selectedFilter === "today" ? "all" : selectedFilter };
      const params: any =
        selectedFilter === "custom"
          ? {
            filter: "custom",
            fromDate: from,
            toDate: to,
          }
          : {
            filter: selectedFilter,
          };

      const resp = await downloadUserReport(type, params);

      // Create blob from response and trigger download
      const blob = new Blob([resp.data], {
        type:
          type === "csv"
            ? "text/csv"
            : type === "excel"
              ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              : "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const filenameBase = `user-registration-report`;
      a.download = `${filenameBase}.${type === "excel" ? "xlsx" : type}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      logger.error("err", err);
      setError("Failed to download report");
    } finally {
      setExportLoading("");
    }
  };

  return (
    <div className="min-h-screen max-w-screen p-4">
      {/* FILTER SECTION */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
        <div className="sm:flex block items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <Filter className="w-5 h-5 text-gray-500" />
            <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
          </div>

          {/* Export button moved to the right corner */}
          <div className="relative sm:mt-0 mt-3">
            <button
              className="inline-flex items-center px-4 py-2 bg-green-600
               text-white font-medium rounded-lg hover:bg-green-700
               focus:outline-none sm:text-lg text-xs focus:ring-2 focus:ring-green-500 
               transition-colors"
              onClick={() => {
                const exportOptions =
                  document.getElementById("export-dropdown");
                exportOptions?.classList.toggle("hidden");
              }}
            >
              <Download className="w-4 h-4 sm:mr-2 mr-0.5" />
              Export Report
              <ChevronDown className="w-4 h-4 sm:ml-2 ml-0.5" />
            </button>

            <div
              id="export-dropdown"
              className="hidden absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-20"
            >
              <div className="py-1">
                {(["csv", "excel", "pdf"] as const).map((type) => (
                  <button
                    key={type}
                    onClick={() => handleExport(type)}
                    // disabled={exportLoading === type}
                    className="flex items-center w-full sm:px-4 px-1 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                  >
                    {/* {exportLoading === type ? (
                      <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                    ) : (
                      <Download className="w-4 h-4 mr-2" />
                    )} */}
                    Download as {type.toUpperCase()}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Filter Options */}
        <div className="space-y-4">
          <div className="flex flex-wrap gap-3">
            {/* {["custom", "week", "month", "year"].map((filter) => (
              <label
                key={filter}
                className={`px-4 py-2 rounded-lg border cursor-pointer transition-colors ${
                  selectedFilter === filter
                    ? "bg-indigo-50 border-indigo-500 text-indigo-700 font-medium"
                    : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
                }`}
              >
                <input
                  type="radio"
                  name="filter"
                  value={filter}
                  checked={selectedFilter === filter}
                  onChange={(e) =>
                    handleFilterChange(e.target.value as FilterType)
                  }
                  className="hidden"
                />
                {filter === "custom"
                  ? "Date Range"
                  : `This ${filter.charAt(0).toUpperCase() + filter.slice(1)}`}
              </label>
            ))} */}
            {["today", "custom", "week", "month", "year"].map((filter) => (
              <label
                key={filter}
                className={`px-4 py-2 rounded-lg border cursor-pointer transition-colors ${selectedFilter === filter
                    ? "bg-indigo-50 border-indigo-500 text-indigo-700 font-medium"
                    : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
                  }`}
              >
                <input
                  type="radio"
                  name="filter"
                  value={filter}
                  checked={selectedFilter === filter}
                  onChange={(e) =>
                    handleFilterChange(e.target.value as FilterType)
                  }
                  className="hidden"
                />

                {filter === "today"
                  ? "Today"
                  : filter === "custom"
                    ? "Date Range"
                    : `This ${filter.charAt(0).toUpperCase() + filter.slice(1)}`}
              </label>
            ))}
          </div>

          {/* Date Pickers */}
          {selectedFilter === "custom" && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  From Date
                </label>
                <DateInput 
                  value={from}
                 onChange={(val : string) => {
                  handleDateInputValidation(val, setFrom)
                 }}
                />  
              
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  To Date
                </label>
                <DateInput 
                value={to}
                onChange={(val : string) => {
                  handleDateInputValidation(val, setTo)
                }}
                />  
               
              </div>

              <div className="flex items-end space-x-2">
                <button
                  onClick={handleApplyFilters}
                  disabled={loading}
                  className="w-48 inline-flex items-center px-6 py-2 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 transition-colors disabled:opacity-50"
                               >
                                 {loading ? (
                                   <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                                 ) : (
                                   <Filter className="w-4 h-4 mr-2" />
                                 )}
                                 {loading ? "Applying..." : "Apply Filters"}
                </button>
                <button
                  onClick={handleReset}
                  disabled={resetLoading}
                  className={`inline-flex items-center px-6 py-2 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors
                                                  ${resetLoading ? "opacity-50 cursor-not-allowed" : "opacity-100 cursor-pointer"}`}
                >
                  <RefreshCw
                    className={`w-4 h-4 mr-2 ${resetLoading ? "animate-spin" : ""}`}
                  />
                  Reset
                </button>
              </div>
            </div>
          )}
        </div>

        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg mt-4">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}
      </div>

      {/* SUMMARY CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl border shadow-sm">
          <p className="text-sm text-gray-600">Total Registrations</p>
          <p className="text-3xl font-bold text-blue-600">
            {totalRegistrations.toLocaleString()}
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl border shadow-sm">
          <p className="text-sm text-gray-600">Individual Users</p>
          <p className="text-3xl font-bold text-green-600">
            {counts.Individual.toLocaleString()}
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl border shadow-sm">
          <p className="text-sm text-gray-600">Advocate Users</p>
          <p className="text-3xl font-bold text-purple-600">
            {counts.Advocate.toLocaleString()}
          </p>
        </div>
      </div>

      {/* GRAPH CARDS */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        <div className="bg-white p-6 rounded-xl border shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <UserCheck className="w-5 h-5 mr-2 text-green-600" />
            Individual Registrations
          </h3>
          {/* {renderLineChart(
            counts.graphData.map((d) => ({
              name: d.name,
              count: d.individual,
            })),
            "#10b981",
          )} */}
          {chartData.length > 0 ? (
            renderLineChart(
              chartData.map((d) => ({
                name: d.name,
                count: d.individual,
              })),
              "#10b981",
            )
          ) : (
            <p className="text-center text-gray-500 mt-20">No data available</p>
          )}
        </div>
        <div className="bg-white p-6 rounded-xl border shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <TrendingUp className="w-5 h-5 mr-2 text-purple-600" />
            Advocate Registrations
          </h3>
          {chartData.length > 0 ? (
            renderLineChart(
              chartData.map((d) => ({
                name: d.name,
                count: d.advocate,
              })),
              "#8b5cf6",
            )
          ) : (
            <p className="text-center text-gray-500 mt-20">No data available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegistrationReport;
